/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Navigation from '../../components/Navigation';
import ProductInfo from './ProductInfo';
import CustomerServiceInvite from './CustomerServiceInvite';
import OrderInfo from './OrderInfo';
import Button from '../../components/Button';
import PaymentInfo from './PaymentInfo';
import EmailForm from './EmailForm';
import OrderDisclaimer from './OrderDisclaimer';
import OutofRefillsNotification from './OutofRefillsNotification';
import styles from './CartPageLayout.css';

const cardIdentifier = ccNum => {
  const numberArray = Array.from(ccNum);
  let card = 'Card';
  if (numberArray[0] === '4') {
    card = 'Visa';
    return card;
  } else if (
    numberArray[0] === '5' &&
    (numberArray[1] === '0' || '1' || '2' || '3' || '4' || '5')
  ) {
    card = 'Mastercard';
    return card;
  } else if (
    (numberArray[0] === '6' &&
      (numberArray[1] === '0' &&
        numberArray[2] === '1' &&
        numberArray[3] === '1')) ||
    (numberArray[1] === '4' &&
      numberArray[2] === ('4' || '5' || '6' || '7' || '8' || '9')) ||
    numberArray[1] === '5'
  ) {
    card = 'Discover Card';
    return card;
  } else if (numberArray[0] === '3' && (numberArray[1] === '4' || '7')) {
    card = 'American Express';
    return card;
  }
  return card;
};

class CartPageLayout extends React.Component {
  static isEmailPresentAndValid() {
    const element = document.getElementById('email');
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      typeof element !== 'undefined' &&
      element != null &&
      element.value.length > 0
    ) {
      if (emailRegex.test(element.value)) {
        return true;
      }
    }
    return false;
  }

  constructor(props) {
    super(props);
    this.updateAfterEmailChange = this.updateAfterEmailChange.bind(this);
    if (this.state && this.state.orders) {
      this.state.orders = {
        ...this.state.orders,
        orderProcessing: false,
      };
    }
  }
  componentDidMount() {
    this.props.getStatesOption();
    if (this.state && this.state.orders) {
      this.state.orders = {
        ...this.state.orders,
        orderProcessing: false,
      };
    }
  }
  updateAfterEmailChange() {
    this.forceUpdate();
  }
  render() {
    const {
      handlePlaceOrder,
      handleEditCCInfo,
      handleEditShipping,
      handleEditCreditCardList,
      defaultPaymentOption,
      handleAuthNetPayment,
      customer,
      product,
      priceInformation,
      prescription,
      shippingAddress,
      cvcNumber = '',
      ccNum,
      billingType,
      shipToType,
      processing,
    } = this.props;

    return _.isEmpty(prescription) ||
      _.isEmpty(priceInformation) ||
      _.isEmpty(product) ? (
      <Redirect to="/" />
    ) : (
      <div>
        <Navigation
          patient={prescription.petName}
          vetPractice={prescription.vetPracticeName}
        />
        <div className={styles.container}>
          {prescription.refillsRemaining <= 0 ||
          prescription.expired === true ? (
            <OutofRefillsNotification />
          ) : null}
          <ProductInfo
            imgSrc={product.imagePath}
            productName={product.productNameUnsanitized}
            price={priceInformation.price}
            strength={product.dose}
            flavorName={product.flavorName}
            quantity={product.quantity}
            packageQtyDisplay={product.packageQtyDisplay}
            refillsRemaining={prescription.refillsRemaining}
            totalRefills={prescription.totalRefills}
          />
          <OrderInfo
            onEditBilling={handleEditCCInfo}
            onEditShipping={handleEditShipping}
            onEditCreditCardList={handleEditCreditCardList}
            hasShippingInfo={!_.isEmpty(shippingAddress)}
            shippingInfo={shippingAddress}
            hasPaymentInfo={!_.isEmpty(defaultPaymentOption)}
            paymentInfo={defaultPaymentOption}
            cvcNumber={cvcNumber}
            cardType={cardIdentifier(ccNum)}
          />
          {product.isSpecialHandling ? (
            <OrderDisclaimer
              specialHandlingInstructions={product.specialHandlingInstructions}
            />
          ) : null}
          <PaymentInfo
            drug={product.productNameUnsanitized}
            drugPrice={priceInformation.price}
            taxPrice={priceInformation.tax}
            shippingPrice={priceInformation.shipping}
            shippingLabel={product.shippingLabel}
          />
          <EmailForm
            onChanged={this.updateAfterEmailChange}
            email={customer.emailAddress}
          />
          <Button
            disabled={
              !(
                defaultPaymentOption &&
                shippingAddress &&
                (customer.emailAddress ||
                  CartPageLayout.isEmailPresentAndValid())
              )
            }
            onClick={() => {
              const creditCardNumberArray = Array.from(
                defaultPaymentOption.creditCardNumber
              );

              if (
                creditCardNumberArray[0] !== 'X' &&
                defaultPaymentOption.paymentGateway === 'AUTH_NET_CIM'
              ) {
                handleAuthNetPayment(
                  defaultPaymentOption,
                  customer,
                  prescription,
                  handlePlaceOrder,
                  product,
                  billingType,
                  shipToType
                );
              } else {
                const noncePayment = null;
                const { paymentProfileId } = defaultPaymentOption;
                handlePlaceOrder({
                  customer,
                  product,
                  prescription,
                  noncePayment,
                  paymentProfileId,
                  billingType,
                  shipToType,
                });
              }
            }}
            submitting={processing}
            className={styles.button}
            id="submit-btn"
            btnText="Submit Order"
          />
          <CustomerServiceInvite />
        </div>
      </div>
    );
  }
}
CartPageLayout.propTypes = {
  getStatesOption: PropTypes.func.isRequired,
  handlePlaceOrder: PropTypes.func.isRequired,
  handleEditCCInfo: PropTypes.func.isRequired,
  handleEditShipping: PropTypes.func.isRequired,
  handleEditCreditCardList: PropTypes.func.isRequired,
  handleAuthNetPayment: PropTypes.func,
  defaultPaymentOption: PropTypes.object,
  customer: PropTypes.object,
  product: PropTypes.object,
  priceInformation: PropTypes.object,
  prescription: PropTypes.object,
  shippingAddress: PropTypes.object,
  cvcNumber: PropTypes.string,
  ccNum: PropTypes.string,
  billingType: PropTypes.string,
  shipToType: PropTypes.string,
  processing: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const processing =
    state && state.orders && state.orders.orderProcessing
      ? state.orders.orderProcessing
      : false;
  return { processing };
}
export default connect(mapStateToProps, null)(CartPageLayout);



// WEBPACK FOOTER //
// ./src/containers/CartPage/CartPageLayout.jsx